const firebaseConfig = {
    apiKey: 'AIzaSyDUnyWH7xV3bjwNNCbGmFTGRlWcE-AlhpU',
    projectId: 'foound',
    //authDomain: "<YOUR-AUTH-DOMAIN>",
    databaseURL: 'https://foound.firebaseio.com',
    storageBucket: 'foound.appspot.com',
};

export { firebaseConfig };
